import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { connect } from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import AccountSubheader from "../components/AccountSubheader";
import Spacer from "../components/Spacer";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { accountHomeViewActions } from "../_actions";
import moment from "moment";
import AccountBackButton from "../components/AccountBackButton";
import SuccessMessage from "../components/SuccessMessage";

class AccountHomeViewHolidayMode extends Component {
  constructor(props) {
    super(props);
    const user = JSON.parse(localStorage.getItem("user"));
    const level = this.props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    this.state = {
      submitSucceeded: false,
    };
    this.renderRadio = this.renderRadio.bind(this);

    this.props.dispatch(accountHomeViewActions.getHolidayMode(user));
  }

  renderField = (props) => {
    const {
      input,
      label,
      type,
      meta: { touched, error, warning },
    } = props;

    const inputStyles = css([
      styles.input,
      touched && error && styles.inputError,
    ]);
    return (
      <div>
        <label className={css(styles.label)}>{label}</label>
        <div>
          <input
            {...input}
            placeholder={label}
            type={type}
            className={inputStyles}
          />
          {touched &&
            ((error && <span className={css(styles.error)}>{error}</span>) ||
              (warning && <span>{warning}</span>))}
        </div>
      </div>
    );
  };

  renderRadio = (props) => {
    const {
      meta: { touched, error, warning },
    } = props;

    const handleClick = () => {
      this.setState({
        submitSucceeded: false,
      });
    };

    return (
      <span>
        <div className={css(styles.checkboxWrapper)}>
          <div className={css([styles.radio])}>
            <span
              className={css([
                styles.radioIcon,
                props.input.checked && styles.radioIconChecked,
              ])}
            />
          </div>
          <strong className={css([styles.label, styles.radioLabel])}>
            {props.label}
          </strong>
        </div>
        <input
          className={css(styles.hidden)}
          {...props.input}
          type={props.type}
          onClick={handleClick}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </span>
    );
  };

  submit = (values) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const level = this.props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    const obj = {
      status: values.status,
      start_timestamp: moment(values.start_timestamp).unix(),
      end_timestamp: moment(values.end_timestamp).unix(),
    };

    this.props.dispatch(
      accountHomeViewActions.setHolidayMode(user.user_id, obj)
    );
    this.setState({
      submitSucceeded: true,
    });
  };
  render() {
    const { handleSubmit, submitSucceeded } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref={`/account/${this.props.match.params.level}/`}
            backLabel={this.props.match.params.level}
            title="Holiday Mode"
          />
          <h2 className={css(styles.label)}>Holiday Mode</h2>
          <p className={css(styles.paragraphSmall)}>
            Holiday mode prevents you from receiving noticiations except for
            “appliance on” alerts.
          </p>
          <Spacer />
          <form onSubmit={handleSubmit(this.submit)}>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="DISABLED"
                label={"Disable Holiday Mode"}
              />
            </label>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="ENABLED"
                label={"Enable Holiday Mode"}
              />
            </label>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="SCHEDULED"
                label={"Schedule Holiday Mode"}
              />
            </label>
            {this.props.accountHomeViewHolidayMode &&
              this.props.accountHomeViewHolidayMode.values.status ===
                "SCHEDULED" && (
                <div>
                  <Spacer />
                  <Field
                    name="start_timestamp"
                    component={this.renderField}
                    label="Schedule start"
                    type="datetime-local"
                  />
                  <Field
                    name="end_timestamp"
                    component={this.renderField}
                    label="Schedule end"
                    type="datetime-local"
                  />
                </div>
              )}
            <Spacer />
            <button type="submit" className={css(styles.buttonGreen)}>
              Save Holiday Mode
            </button>
          </form>
          {this.state.submitSucceeded && (
            <SuccessMessage message="Holiday mode saved" />
          )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const startDefault = new Date();
  startDefault.setMinutes(
    startDefault.getMinutes() - startDefault.getTimezoneOffset()
  );

  let numWeeks = 2;
  let endDefault = new Date();
  endDefault.setDate(endDefault.getDate() + numWeeks * 7);

  const initialValues = {
    status: state.accountHomeView.detail.status,
    start_timestamp: state.accountHomeView.detail.start_timestamp
      ? moment(state.accountHomeView.detail.start_timestamp * 1000)
          .toISOString()
          .slice(0, 16)
      : startDefault.toISOString().slice(0, 16),
    end_timestamp: state.accountHomeView.detail.start_timestamp
      ? moment(state.accountHomeView.detail.end_timestamp * 1000)
          .toISOString()
          .slice(0, 16)
      : endDefault.toISOString().slice(0, 16),
    // email_report: email_report[state.account.detail[1].email_report]
  };
  return {
    initialValues,
    ...state.form,
    // ...state
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewHolidayMode",
    enableReinitialize: true,
    // validate
  })(AccountHomeViewHolidayMode)
);
